module.exports = __webpack_public_path__ + "a5810bd53b83edeeb0846eb897d2011d.MP3";